/**
 * 越南语
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "Trung",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "AnhName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "Truyền thống Trung Hoa",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "Nhật",
			langimg: "../assets/zg.png"
		},
		{
			type: "Vietnamese",
			name: "ViệtName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "Malay",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "Name",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "Thái",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "Nga",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "Indonesia",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Vietnamese",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "trang chủ",
		activity: "hoạt động",
		to_promote: "Phần",
		help: "Cứu",
		my: "của"
	},
	// 提示
	prompt: {
		verification: "Lỗi mã kiểm tra",
		account: "Số tài khoản 8-20, số hay chữ cái trong trắng",
		password: "Mật khẩu lớn hơn hoặc bằng sáu chữ số + thư hay mã tổ hợp chữ ký",
		two: "Hai mật khẩu không khớp với nhau.",
		successful: "đã đăng nhập thành công",
		loginsuccessful: "Thành công Đăng nhập",
		null: "Không thể bỏ mật khẩu tài khoản",
		Binding: "Đã thành công",
		address: "Xin hãy điền địa chỉ",
		Please_choose: "Hãy chọn một mục trước và nhập số lượng cá cược",
		Bet_type: "Hãy chọn kiểu cá trước",
		success: "Tố thành đạt",
		complete_password: "Hãy nhập mật khẩu đầy đủ.",
		copy_success: "Chép vào bảng nháp",
		copy_fail: "Lỗi sao chép",
		Set_success: "Đặt thành công",
		Set_password: "Hãy đặt một mật khẩu số sáu, không thể chứa 'ký tự, khớp và khoảng trống'",
		update_success: "Sửa thành công",
		input_number: "Nhập số",
		addressvalue: "Hãy chọn địa chỉ ví"
	},
	head: { //头部
		luckyhash: "Đặt cược",
		address: "địa chỉ ví bị khóa",
		history: "Quá khứ đặt cược",
		help: "Cứu",
		lotteryRecord: "Ghi chép xổ số",
		notice: "Danh sách Thông báo",
		question: "vấn đề chung",
		performance: "Phần",
		add_address: "Thêm ví",
		asset: "Mật khẩu tài sản",
		balance: "Thông tin",
		exchangeRecord: "trao",
		forrecord: "Giao lưu",
		language: "Thiết lập Ngôn ngữ",
		update_assets_password: "Sửa đổi mật khẩu",
		update_login_password: "Sửa mật khẩu đăng nhập",

		myteam: "Đội của tôi",
		recharge: "Nạp bằng cân",
		setting: "thiết lập",
		transactiondetails: "Thành tích đặt cược",
		transfer: "Nhiệm vụ",
		user: "Trung tâm cá nhân",
		userInfo: "Dữ liệu cá nhân",
		withdrawal: "Rút",
		commission: "Ngừng lại",
		withdrawalRecord: "Thu hồi",
		top_up: "Tải về"
	},
	withdrawalRecord: {
		Select_month: "Chọn tháng",
		afterPrice: "dư",

	},
	withdrawal: {
		withdrawalrecord: "Thu hồi",
		commission: "Có thể rút",
		number: "Số để chuyển",
		withdrawal_number: "Số rút lui",
		money_address: "Địa chỉ ví",
		addressvalue: "Hãy chọn địa chỉ ví",
		poundage: "Phí dịch vụ",
		immediately: "Ngay lập tức rút",
		Warm_prompt: "Nguồn tin nóng: Xin hãy điền địa chỉ ví đúng, nếu không bạn sẽ không thể rút tiền. Một khi địa chỉ rút ra khỏi ví đã được điền vào và buộc vào, nó không thể thay đổi. Nếu bạn cần sửa đổi nó, hãy liên lạc với dịch vụ khách hàng.",
		input_password: 'Hãy nhập mật khẩu của tài sản',
		betting: "Đặt",

	},
	userInfo: {
		Head_portrait: "Avatar riêng",
		account: "Số tài khoản",
		Choose_picture: "Chọn ảnh riêng",
		cancel: "hủy",
		determine: "xác định"
	},
	user: {
		wallet_account: "Tài khoản ví",
		balance: "Thông tin",
		top_up: "Nạp",
		withdrawal: "Rút",
		my_wallet: "Ví của tôi",
		add_wallet: "Thêm ví",
		look: "Ghi chú xem",
		look_all: "Xem tiếp đi",
		Pack_up: "Cất đi.",
		For_record: "Giao lưu",
		bettingRecord: "Giao dịch chi tiết",
		reward: "Phần thưởng",
		goCustomerLink: "Dịch vụ trực tuyến",
		Commission_account: "Tài khoản Ủy ban",
		transfer: "chuyển",
		number: "Cá cược",
		transactiondetails: "Xem chi tiết",
		day: "Đặt hôm nay",
		day_winning: "Thắng hôm nay",
		my_team: "Đội của tôi",
		about_we: "Về chúng ta",
		center: "Trung tâm dịch vụ",
		setting: "thiết lập",
	},
	transfer: {
		money: "Tài khoản",
		account_balance: "Tài khoản",
		number: "Số để chuyển",
		select: "Hãy chọn",
		Immediately_transfer: "ngay lập tức",
		password: "Hãy nhập mật khẩu của tài sản",
		betting: "Đặt",

	},
	transactiondetails: {
		type: "Kiểu",
		input_type: "Hãy chọn kiểu",
		date: "ngày",
		select_date: "Hãy chọn ngày",
		select: "truy",
		bettingmoney: "Số Cá",
		winning_amount: "Giá thắng",
		time: "giờ",
		not: "không có dữ liệu",
		B1: 'Lucky Hash Cỡ may mắn',
		B2: 'Lucky hash may mắn phối hợp',
		B3: 'Vượng Tài Long và hổ may mắn',
		B4: '(Nói tiếng Tây Ban Nha)',
		B5: 'Số may mắn của hash',
		A1: 'Hasti Entertainment City- may xe Name',
		A2: 'Hasti Entertainment City- Lucky Speedboat',
		A3: 'Hasti Entertainment City- Lucky Horse Racing Racing.',
		A4: 'Hasti Entertainment City- May size',
		A5: 'The Hashimi Entertainment City. may mắn combination',
		A6: 'Thành phố Giải trí Hashimi. Rồng may mắn và hổ.',
		A7: '♪ Hasti Entertainment City ♪ ♪ Lễ hội may mắn ♪',
		A8: 'Hash Entertainment City- số hên',
		options: [{
			value: "Lucky hash - tay đôi",
			label: "B1",
		},
		{
			value: "Xoá(delete)",
			label: "B2",
		},
		{
			value: "Dùng gián điệp Long Hổ may mắn",
			label: "B3",
		},
		{
			value: "Lucky hashtat may",
			label: "B4",
		},
		{
			value: "Chỉ có can đảm",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "Sửa mật khẩu đăng nhập",
		assets_pwd: "Mật khẩu tài sản",
		not: "Chưa đặt",
		yes: "Đặt",
		language: "Thiết lập Ngôn ngữ",
		exit: "kí vào đây",

	},
	recharge: {
		recharge_code: "Tải về",
		Chain_type: "Kiểu chuỗi",
		address: "Địa chỉ nạp",
		copy_address: "Chép địa chỉ",
		remind: "Nhắc hoạt động",
		content: "Nội dung nội dung nội dung"
	},
	myteam: {
		select: "truy",
		time: "ngày",
		money: "Ủy ban ngày",
		people: "Số cấp dưới trực tiếp",
		team: "nhóm",
		jryj: 'Kết quả hôm nay',
		jrsy: 'Thu nhập hôm nay',
		ljsy: 'thu nhập tích lũy',
		friendsCategoryList: ['bạn lớp đầu tiên', 'bạn thứ hai', 'bạn cấp ba', 'Bạn lớp 4', 'Bạn cấp 5'],
	},
	login: {
		order_password: "Mật khẩu cũ",
		input_ordpwd: "Hãy nhập mật khẩu cũ.",
		new_pwd: "Mật khẩu mới",
		number: "Vui lòng đặt 6-16 từ chữ cái trên và chữ cái dưới +",
		six_pwd: "Hãy nhập mật khẩu số sáu.",
		confirmPassword: "Xác nhận mật khẩu",
		confirm: "xác nhận",
	},
	forrecord: {
		spending: "Chi phí trao đổi",
	},
	exchangeRecord: {
		exchangeRecord: "trao",
		record: "ghi",
		For_spending: "Chi phí trao đổi",
		money: "Tiền trao đổi",
		exchange_number: "Chất lượng trao đổi",
		number: "Số",
		market_price: "Giá thị trường",
		Miners_fee: "Phí khai mỏ",
		input_money: "Hãy nhập số tiền trao đổi",
		Get_the_amount: "Số đếm",
		Can_be: "Sắn sàng",
		address: "Địa chỉ ví",
		Immediatelychange: "Xin hãy cứu tôi.",
		Warm_prompt: "nhắc",
		details: "Cụ thể chi tiết cụ thể, cụ thể chi tiết cụ thể, cụ thể chi tiết cụ thể, cụ thể chi tiết cụ thể, cụ thể chi tiết cụ thể cụ thể cụ thể chi, cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể chi, cụ thể chi tiết cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể cụ thể"
	},
	balance: {
		balance_of: "dư",
		data: "ngày",
		dataPickerRange: "Hãy chọn",
		select: "truy",
		to: 'to'
	},
	asset: {
		password: "Hãy đặt một mật khẩu số sáu, không thể chứa 'ký tự, khớp và khoảng trống'",
		confirm: "xác nhận",
	},
	add_address: {
		money_address: "Hãy nhập địa chỉ ví (giá rẻ)",
		save: "bảo:"
	},
	spread: {
		cumulative: "Giấy mời tích hợp",
		people: "người",
		make: "Được",
		Continue_to: "Tiếp tục phấn đấu vì giải thưởng lớn.",
		url: "Chia sẻ liên kết",
		Friends_registered: "Đăng ký bằng bạn",
		money: "Ví liên kết",
		Friends_deal: "Giao dịch bằng Bạn",
		copy_url: "Chép liên kết",
		my_group: "Đội của tôi",
		look: "Thông tin về ảnh",
		directCount: "Số cấp dưới trực tiếp",
		group: "Số nhóm",
		Commission_withdrawal: "Ngừng lại",
		historyAward: "Hội đồng tiền sử",
		yesterdayAward: "Ủy ban hôm qua",
		currentAward: "Nợ tiền hoa hồng",
		todayAward: "Chương trình hôm nay",
		my_invite: "Mã mời của tôi",
		copy_invite: "Chép mã thư mời",
		top_title: "Thượng cấp.",
		update: "Nó không thể thay đổi sau khi cha mẹ bị ràng buộc",
		nikname: "Hãy nhập vào nick phụ huynh cần ghi",
		binding: "Description",
		Commission_ratio: "Phí hoa hồng",
		level: "cấp",
		ratio: "Tỷ lệ tái tạo (mức độ cá độ)",
		Directly_under: "Cấp trực tiếp",
		first: "Đầu tiên",
		levelone: "cấp",

	},
	performance: {
		datatime: "ngày",
		pick: "Hãy chọn",
		select: "truy",
		total: "Kết quả hôm nay",
		performance: "Thông tin:",
		directCount: "Số lần thử lại:",
		todayTotalPerformByDirect: "Biểu hiện của các cầu thủ trực tiếp",
		other: "Số lần thử lại:",
		todayTotalPerformByOther: "Biểu hiện của các cầu thủ khác",
		Commission_withdrawal: "Ngừng lại",
		historyAward: "Hội đồng tiền sử",
		yesterdayAward: "Ủy ban hôm qua",
		currentAward: "Nợ tiền hoa hồng",
		todayAward: "Chương trình hôm nay",
		Commission_ratio: "Phí hoa hồng",
		level: "cấp",
		ratio: "Tỷ lệ tái tạo (mức độ cá độ)",
		Directly_under: "Cấp trực tiếp",
		first: "Đầu tiên",
		levelone: "cấp",
	},
	lotteryRecord: { //开奖记录
		block: "khối",
		highly: "khối cao",
		results_of: "kết quả"
	},
	help: {
		DAPP: "Trò chơi DAPP",
		a: "Chép địa chỉ cuộc chơi cho miền- ba lần chuyển nhượng",
		b: "Mở trang web này trong trình duyệt bao tải ví (mạng lưới TRX), bạn có thể đặt cược vào DAPP ngay lập tức mà không sao chép.",
		Focus_on: "Vui lòng chú ý làm lành trang chủ của chúng tôi để có địa chỉ giao dịch mới nhất.",
		login: "Đăng nhập vào trang web chính thức của trường sóng để truy vấn giá trị việc chặn của văn bản",
		hash: "Bạn có thể truy vấn giá trị văn chương khối trên trang web chính thức của trường sóng",
		you: "Bạn có thể xem trang web chính thức của trường sóng",
		login_website: "Đăng nhập vào trang web chính thức của trường sóng.",
		query: "Hỏi giá trị văn chương khối của bạn trên",
		look: "Nhấn vào để xem hướng dẫn",
		congratulations: "Chúc mừng.",
		winning: "Nếu anh thắng giải, hệ thống sẽ trả giải thưởng cho anh trong vòng một phút.",
		address: "Nếu anh thắng giải, hệ thống sẽ trả giải thưởng về địa chỉ chuyển hàng trong vòng một phút.",
		number: "Mua usdt và DX trong bộ trao đổi tiền tệ số.",
		skip: "Nếu ví của anh đã có chúng tôi và TRX, anh có thể bỏ qua đoạn này",
		Digital_currency: "Hãy mua ust và lùa trong bộ trao đổi tiền tệ số kỹ thuật số, rồi chuyển ust và lùa về (ví) của bạn. Bạn có thể sử dụng ví được đăng ký trên trang web ví tập trung sau:",
		platform: "bục",
		url: "trang",
		tutorial: "Name",
		vpn: "Lời khuyên thân thiện: nếu bạn không thể mở bức điện t ín, bạn có thể dùng thần VPN",
		vpnurl: "Trang web đèn ma thuật VPN",
		whirlwind: "Trang web Name",
		can_login: "Bạn có thể đăng nhập",
		why: "Sao lại chọn XXXX",
		most_fair: "Công bằng nhất",
		play: "Không đá, không thả, không can thiệp.",
		Publicly_available: "Kết quả được tạo ra ngẫu nhiên, kết quả được thống nhất, không thể thay đổi, và có thể được kiểm tra công khai",
		security: "An",
		no_money: "Có thể thấy số vốn lao động không cần lo lắng về việc mất tiền",
		Cannot: "Tài liệu chuyển nhượng của chủ nhân có thể được xem và không thể công bố sai lầm",
		Visi_convenient: "Càng tiện",
		Without_registration: "Không cần đăng ký, không cần phải nạp lại, không cần phải yêu cầu rút lui.",
		questions: "vấn đề chung",
		one: "Cái gì là văn chương",
		dna: "Khối cần sa là DNA của một phần dữ liệu. Mỗi khối cần sa là riêng biệt, ngẫu nhiên và không thể phá được.",
		lookintroduce: "Nhấn vào để xem giới thiệu giá trị Has của Baidu Encyclopedia。",
		what: "Kiểu gì",
		Block_chain: "Đơn giản là chuỗi tắc là cơ sở dữ liệu chia sẻ nơi lưu giữ dữ liệu hay thông tin. Nó có đặc điểm là không giả mạo, để lại dấu vết trong toàn bộ quá trình, định vị, mở cửa và trong suốt, bảo trì tập thể, vân vân.",
		wallet: "Ví bị tâm? Ví trung gian? Tại sao cái ví t ập trung lại không truy vấn chuyển?",
		example: "Ví dụ, nếu địa chỉ ví của bạn là một và bạn chuyển địa chỉ e sang 10usdt, nhưng bạn dùng mật giá của việc chuyển giao dịch để truy vấn, bạn chỉ có thể truy vấn việc chuyển giao dịch giữa địa chỉ tài khoản ngẫu nhiên của một nhà cung cấp dịch vụ B (C hay D, v. v. và E. Cũng vậy, e không thể biết liệu anh có chuyển số tiền này đi hay không, bởi vì anh chỉ có thể thấy rằng đó là địa chỉ tài khoản B mà anh ta chuyển khoản sau mười lần. Đây là lý do tại sao cái ví tập trung không thể truy vấn thông tin chuyển thực sự trên giày khối.",
		why_winning: "Tại sao tôi thắng hay không thắng liên tiếp",
		First: "Trước hết, đây là một sự kiện xác suất nhỏ chưa được giải thưởng nhiều lần liền",
		small: "Định nghĩa các sự kiện Xác suất nhỏ",
		second: "Thứ hai, chiến thắng và không thắng là các sự kiện ngẫu nhiên, và tần suất các sự kiện ngẫu nhiên sẽ dẫn đến một giá trị ổn định. Trong trường hợp lặp lại, khả năng xuất hiện của mọi người có thể ngang bằng nhau. Đồng thời, các sự kiện ngẫu nhiên sẽ tuân theo luật của các con số lớn (dưới điều kiện thử vẫn không thay đổi, lặp lại nhiều lần, và tần suất các sự kiện ngẫu nhiên tương tự với định luật của các số lớn). Khi tần số chuyển hàng tiếp tục tăng, khả năng thắng thua hoặc không thắng sẽ có xu hướng ổn định giá trị. Vì vậy xin tiếp tục chuyển đi. khả năng thắng giải sẽ tăng lên.",
		whydelay: "Sao trễ vậy",
		Click_to_view: "Nhấn vào để xem môi trường tốc độ của chuỗi tắc： 《Niềm tin là điều quan trọng, chậm là điều quan trọng.》",
		six: "Tại sao lại có chìa khóa khi chuyển tiền, vậy thì chúng ta sẽ chọn loại nào? Tôi nên chọn cái nào?",
		global: " Có nhiều dây chuyền công cộng nổi tiếng khắp thế giới.",
		click_look: "Nhấn vào để xem giới thiệu hàng loạt hệ thống công cộng trên to àn cầu.",
		how: "Khi chuyển tiền tệ, tôi phải làm gì nếu tôi chuyển địa chỉ hay chọn nhầm loại tiền tệ? Tôi quay lại nhé?",
		For_instance: " Ví dụ, khi bạn chuyển tiền cho chúng tôi, bạn nên chọn giá trị 3C dưới USD, nhưng nếu bạn chọn Omni hay usquy 20 dưới các kiểu USD khác, bạn sẽ mất tiền, mà không thể lấy lại được.",
		How_to_force: "Nhấn vào để xem phải làm gì nếu bạn chuyển sai tiền tệ?",
		Other_problems: "Các vấn đề khác",
		callwe: "Nếu có thắc mắc gì xin liên lạc với chúng tôi",
		immediately: "Đặt ngay.",
		company: "Thông tin công ty",
		link: "Liên",
		register: "Tiền tệ số bộ lạc bộ",
		Already_have: "Nếu bạn đã có ví, bạn có thể bỏ qua bước này",
		download: "Tải về và đăng ký tiền tệ bộ bộ",
		com_title: "Trang web tập huấn về tiền tệ số ảo là như sau:"
	},
	register: { //登录注册
		login_tips: "Xin hãy đặt lại mật khẩu đăng nhập",
		address: "Hãy nhập địa chỉ ví",
		confirm: "Xác nhận mật khẩu",
		confirmupdate: "Xác nhận sửa",
		toRegister: "Tới đăng ký",
		agreement: "Ký vào và đồng ý",
		user: "Thỏa thuận người dùng",
		policy: "Chính sách cá nhân",
		welcome: "Chào mừng đến",
		login: "Đăng nhập vào tài khoản của bạn",
		forget: "Quên mật khẩu",
		nowLogin: "Ký vô.",
		nologin: "Không đăng nhập t ạm thời",
		new: "Tạo tài khoản mới",
		login: "Là tài khoản đăng nhập",
		account: "Số tài khoản 8-20, số hay chữ cái trong trắng",
		password: "Mật khẩu lớn hơn hoặc bằng sáu chữ số + thư hay mã tổ hợp chữ ký",
		confirm_password: "Xác nhận mật khẩu",
		inviteCode: "Hãy nhập mã giấy mời (tùy chọn)",
		verificationCode: "Hãy nhập mật mã kiểm tra.",
		toRegister: "ghi",
		noaccount: "Không tài khoản",
		toLogin: "Đi đăng nhập"
	},
	address: {
		warmprompt: "Nguồn tin nóng: Xin hãy điền địa chỉ ví đúng, nếu không bạn sẽ không thể rút tiền. Một khi địa chỉ rút ra khỏi ví đã được điền vào và buộc vào, nó không thể thay đổi. Nếu bạn cần sửa đổi nó, hãy liên lạc với dịch vụ khách hàng.",
		tips: "Hãy đính kèm ít nhất một địa chỉ ví. Bạn không thể lấy nó khi bạn quên mất mật khẩu.",
		TRC20: "Để tránh lỗi nhập, xin hãy sao chép và bấm dài ở đây để paste (trak20)",
		toBind: "Đóng lại đi",
		noBind: "Không bị ràng buộc tạm thời",
	},
	luckyhash: { //幸运哈希
		walletName: 'Ví liên kết',
		exchange: "trao",
		reward: "Phần",
		Customerservice: "dịch vụ khách",
		instructions: "giải thích",
		luckyhash: "Hasit may mắn",
		entertainment: "Hasti Entertainment City",
		Doublesided: "hai mặt",
		odds: "Lợi",
		immediately: "Đặt ngay.",
		combination: "phối",
		LongHuge: "Long Hổ hợp pháp",
		baccarat: "Bargara",
		gallbladder: "Mật mã",
		Hashracingcar: "Đua Hash",
		Hashspeedboat: "thuyền cao tốc Name",
		Hashracing: "Đua ngựa hoang",
		bothsides: "hai mặt",
		problem: "vấn đề chung",
		all: "Xem tiếp đi",
		friend: "Cộng sự hợp tác"
	},
	history: {
		block: "khối",
		type: "Kiểu",
		big: "lớn",
		highly: "khối cao",
		results_of: "kết quả"
	},
	entertainment: {
		lastBlock: "Tập tin trước",
		resultValue: "Kết quả xổ số",
		currentblock: "Khối hiện tại",
		nextBlock: "♫ Dãy số ♫",
		toLotteryRecord: "Ghi chép xổ số",
		block: "khối",
		money1: "bao nhiêu tiền",
		type: "Kiểu",
		all: "Xem tiếp đi",
		both_sides: "hai mặt",
		big: "lớn",
		small: "Nhỏ",
		single: "đơn",
		double: "đôi",
		champion: "Vô địch",
		yajun: 'Comment',
		he: 'và',
		champion_one_size: "Chỉ cỡ vô địch",
		crown: "Name",
		andbig: "Comment",
		andsmall: "Và nhỏ",
		andsingle: "Name",
		anddouble: "Và gấp đôi",
		championtwo: "Hai đích",
		combination: "phối",
		forlarge: "Đại diện",
		smallsingle: "Thiết lập nhỏ",
		large_double: "Name",
		small_double: "Tiểu Linh",
		Long_Huge: "Long Hổ hợp pháp",
		dragon: "VòngName",
		tiger: "Thuần!",
		us: "đóng",
		baccarat: "Bargara",
		zhuang: "XuangName",
		idle: "Name",
		gallbladder: "Mật mã",
		Atotalof: "chung",
		note: "ghi chú",
		Check_the_details: "Xem chi tiết",
		money: "Tạo ví",
		pause: "Chọn máy",
		reset: "Đặt",
		inputmoney: "Hãy nhập số lượng",
		submit: "Gởi",
		password: "Hãy nhập mật khẩu giao dịch",
		betting: "Đặt",
		determine: "xác định",
	},
	details: {
		block: "khối",
		money: "bao nhiêu tiền",
		type: "Kiểu",
		resultValue: "Kết quả xổ số",
		all: "Xem tiếp đi",
		address: "Địa chỉ đặt cược",
		toLotteryRecord: "Ghi chép xổ số",
		money: "Đặt ví",
		copy: "Chép địa chỉ cá",
		ts: "Xin đừng dùng địa chỉ của giao dịch, nếu không sẽ không nhận được phần thưởng.",
		USDT: "Xin hãy chuyển trường sóng dùng miền (giá rẻ đôi)",
		Betting_amount: "Số Cá",
		inputmoney: "Hãy nhập số cá cược",
		confirm: "xác nhận",
		cancel: "hủy",
	},
	data: {
		noData: 'Không có dữ liệu',
		deleteSuc: 'Xoá thành công',
		iscon: 'Xác nhận cá?',
		fenpan: 'Không được phép cá cược trong thời gian đóng cửa.',
		erweima: 'Lưu mã QR'
	},
	announcement: {
		title: 'Thông báo mới nhất',
		close: 'Khép kín',
	},
	phone: {
		title: 'Số điện thoại đính',
		phone: 'Số di động',
		input: 'Hãy nhập số điện thoại di động bị ràng buộc',
		code: 'Mật khẩu',
		inputcode: "Hãy nhập mật mã kiểm tra.",
		getCode: 'Lấy mật khẩu',
		details: 'Xin hãy điền mã vùng và số điện thoại trước.',
		success: 'Mật khẩu được gửi thành công',
		bsuccess: 'Đã thành công',
		jiaoyi: 'Xin hãy đặt mật khẩu giao dịch trước.',
		caozuo: "Chiến dịch thành công",
		touxiang: "Hãy chọn ảnh",
		buzu: 'Xin lỗi, tín dụng của anh đang cạn dần',
		tuiguan: 'Trung tâm:',
		qubie: 'Nhấn vào để xem sự khác biệt giữa ví khối tụ',
		yhm: 'Hãy nhập tên người dùng',
		mm: 'Hãy nhập mật khẩu.',
		xqgg: 'Đi coi thử đi.',
		llwm: 'liên lạc với',
		lj: 'Xin hãy kết nối ví trước',
		dk: 'Vui lòng mở nó trong ứng dụng ví tiền',
		qd: 'Chúng tôi mong bạn tham gia',
		yjmx: 'Thông tin Ủy ban'
	},
	vip: {
		jl: "Phần",
		xrjl: 'Phần thưởng mới',
		ckgz: 'Xem luật',
		zcsj: 'Đăng ký',
		qbsj: 'Số điện thoại và ví',
		dlq: 'vô chủ',
		qwc: 'Để hoàn thành',
		ylq: 'Nhận',
		tgrw: 'Nhiệm vụ',
		rwjl: 'Phần thưởng',
		yq: 'giấy',
		ghy: 'Bạn chất lượng',
		lqcg: 'Đã nhận',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Vietnamese.js